import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../../app/api/routes';
import { MARK_UNIQUE_JOIN_REQUEST_RESOURCE, JOIN_REQUESTS_RESOURCE } from '../../constants';

const MarkUniqueJoinRequestService = ComposedComponent =>
  reduxFetch([
    {
      resource: MARK_UNIQUE_JOIN_REQUEST_RESOURCE,
      method: 'put',
      request: (id, callback, rejectCallback, t) => ({
        url: apiRoutes.markUniqueJoinRequest(id),
        meta: {
          removeFromOtherList: {
            resource: JOIN_REQUESTS_RESOURCE,
            idProp: 'id',
            id,
          },
          callback,
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'markUniqueJoinRequestFailed'),
            onSuccessMessage: t('markUniqueJoinRequestSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default MarkUniqueJoinRequestService;
